import {useMutation} from "@tanstack/react-query";

import {removeSupplierNoteMutationOptions} from "./remove-supplier-note.mutation-options";

export function useRemoveSupplierNote(supplierId: string) {
  return useMutation(removeSupplierNoteMutationOptions(supplierId));
}
